import {
  Alert,
  Autocomplete,
  Button,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { Card, Col, Container, Row, Table } from "react-bootstrap";
import React, { Fragment, useEffect, useRef, useState } from "react";
import {
  createNewPromotion,
  fetchPromotionList,
  fetchEditPromotion,
  fetchImportPromotionProducts,
} from "../actions/promotion";
import { useNavigate, useParams } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";

import Breadcrumb from "../components/Admin/Reusable/Breadcrumb";
import DeleteIcon from "@mui/icons-material/Delete";
import FileUploadRoundedIcon from "@mui/icons-material/FileUploadRounded";
import InputField from "../components/Admin/Reusable/InputField";
import SelectStatus from "../components/Admin/Reusable/Form/SelectStatus";
import SubmitButtonForm from "../components/Admin/Reusable/Form/SubmitButtonForm";
import { basicFormValidationHandler } from "../utils";
import { fetchCountryFormList } from "../actions/country";
import { isEmpty } from "lodash";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import FormSystemInformation from "../components/Admin/Reusable/FormSystemInformation";
import {
  fetchProductList,
  fetchProductListPromotion,
} from "../actions/product";
import { fetchCompanyFormList } from "../actions/company";
import { fetchCustomFormExtendedList } from "../actions/customer";
import { fetchStoreFormExtendedList } from "../actions/store";
import {
  fetchProductCategoryAllFormList,
  fetchProductCategoryList,
} from "../actions/productCategory";
import CloseIcon from "@mui/icons-material/Close";
import FormTitleMain from "../components/Admin/Reusable/FormTitleMain";

const UploadField = ({
  handleFileChange,
  placeholder,
  fieldName,
  className,
}) => {
  return (
    <div className={className}>
      <label>
        <input
          className="test-test"
          id={`file-input-${fieldName}`}
          name={fieldName}
          accept={".jpg, .png"}
          multiple={false}
          type="file"
          hidden
          onChange={handleFileChange}
        />
        <Button
          variant="contained"
          component="span"
          className="default-btn-primary"
          size="small"
          startIcon={<FileUploadRoundedIcon />}
        >
          {placeholder}
        </Button>
      </label>
    </div>
  );
};

const PromotionAdd = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const { t } = useTranslation();

  //breadcrumb
  const translateForm = "promotionsForm";
  const translateModule = "promotions";
  const pageType = id ? "Edit" : "Add";
  const breadcrumbItems = [
    { label: t(`breadcrumb.${translateModule}`) },
    {
      label: t(`breadcrumb.${translateModule}${pageType}`),
      active: true,
    },
  ];

  const [selectedCompany, setSelectedCompany] = useState(null);
  const [selectedStore, setSelectedStore] = useState(null);
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedCategoryType, setSelectedCategoryType] = useState("");
  const [selectedCategoryValue, setSelectedCategoryValue] = useState("");
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedProductType, setSelectedProductType] = useState("");
  const [selectedProductValue, setSelectedProductValue] = useState("");
  const [isImportingCategories, setIsImportingCategories] = useState(false);
  const [isImportingProducts, setIsImportingProducts] = useState(false);
  const categoryImportInputRef = useRef(null);
  const productImportInputRef = useRef(null);

  const [dataForm, setDataForm] = useState({
    companyList: [],
    storeList: [],
    accountList: [],
    categoryList: [],
    productList: [],
  });

  const flattenCategories = (categories) => {
    let result = [];

    const traverse = (items) => {
      items.forEach((item) => {
        result.push({
          id: item.id,
          name: item.name,
        });
        if (item.children && item.children.length > 0) {
          traverse(item.children);
        }
      });
    };

    traverse(categories);
    return result;
  };

  const handleInputChangeCategory = (field, value) => {
    if (field === "categoryId") {
      setSelectedCategory(value);
    } else if (field === "type") {
      setSelectedCategoryType(value);
    } else if (field === "value") {
      setSelectedCategoryValue(value);
    }
  };
  const handleInputChangeProduct = (field, value) => {
    if (field === "productId") {
      setSelectedProduct(value);
    } else if (field === "type") {
      setSelectedProductType(value);
    } else if (field === "value") {
      setSelectedProductValue(value);
    }
  };

  const handleAddToFormTableCategory = () => {
    if (selectedCategory && selectedCategoryType && selectedCategoryValue) {
      // Proveri da li kategorija već postoji u categoryList
      const isCategoryExists = dataForm.categoryList.some(
        (category) => category.id === selectedCategory.id
      );

      if (!isCategoryExists) {
        const newCategory = {
          id: selectedCategory.id,
          name: selectedCategory.name,
          parentName: selectedCategory.parentName,
          type: selectedCategoryType,
          value: selectedCategoryValue,
        };
        setDataForm((prevState) => ({
          ...prevState,
          categoryList: [...prevState.categoryList, newCategory],
        }));
        setSelectedCategory(null);
        setSelectedCategoryType("");
        setSelectedCategoryValue("");
      } else {
        toast.error("Ova kategorija je već dodata!", { theme: "colored" });
      }
    } else {
      toast.error("Morate popuniti sva polja!", { theme: "colored" });
    }
  };
  const handleAddToFormTableProduct = () => {
    if (selectedProduct && selectedProductType && selectedProductValue) {
      // Proveri da li kategorija već postoji u productList
      const isProductExists = dataForm.productList.some(
        (product) => product.id === selectedProduct.id
      );

      if (!isProductExists) {
        const newProduct = {
          id: selectedProduct.id,
          name: selectedProduct.name,
          categoryName: selectedProduct.categoryName,
          type: selectedProductType,
          value: selectedProductValue,
        };
        setDataForm((prevState) => ({
          ...prevState,
          productList: [...prevState.productList, newProduct],
        }));
        setSelectedProduct(null);
        setSelectedProductType("");
        setSelectedProductValue("");
      } else {
        toast.error("Ova kategorija je već dodata!", { theme: "colored" });
      }
    } else {
      toast.error("Morate popuniti sva polja!", { theme: "colored" });
    }
  };

  const normalizeImportedPromotionProducts = (responseData) => {
    const importedItems = Array.isArray(responseData)
      ? responseData
      : responseData?.items ||
        responseData?.products ||
        responseData?.content ||
        responseData?.data ||
        [];

    if (!Array.isArray(importedItems)) {
      return [];
    }

    return importedItems
      .map((item) => {
        const productId = item?.referenceId ?? item?.productId ?? item?.id;
        const entityType =
          item?.itemType ??
          item?.referenceType ??
          (item?.type === "PRODUCT" ? item.type : "");
        const valueType =
          item?.valueType ??
          item?.promotionType ??
          item?.discountType ??
          (item?.type && item?.type !== "PRODUCT" ? item.type : "");
        const matchedProduct = productList.find(
          (product) => product.id === productId
        );
        const value = item?.value ?? item?.points ?? item?.amount ?? "";

        if (!productId || (entityType && entityType !== "PRODUCT")) {
          return null;
        }

        return {
          id: productId,
          name:
            item?.name ??
            item?.productName ??
            item?.referenceName ??
            matchedProduct?.name ??
            "",
          categoryName:
            item?.categoryName ??
            matchedProduct?.categoryName ??
            matchedProduct?.parentName ??
            "",
          type: valueType,
          value,
        };
      })
      .filter((item) => item && item.id && item.type && item.value !== "");
  };

  const normalizeImportedPromotionCategories = (responseData) => {
    const importedItems = Array.isArray(responseData)
      ? responseData
      : responseData?.items ||
        responseData?.categories ||
        responseData?.content ||
        responseData?.data ||
        [];

    if (!Array.isArray(importedItems)) {
      return [];
    }

    return importedItems
      .map((item) => {
        const categoryId = item?.referenceId ?? item?.categoryId ?? item?.id;
        const entityType =
          item?.itemType ??
          item?.referenceType ??
          (item?.type === "CATEGORY" ? item.type : "");
        const valueType =
          item?.valueType ??
          item?.promotionType ??
          item?.discountType ??
          (item?.type && item?.type !== "CATEGORY" ? item.type : "");
        const matchedCategory = allCategoryList.find(
          (category) => category.id === categoryId
        );
        const value = item?.value ?? item?.points ?? item?.amount ?? "";

        if (!categoryId || (entityType && entityType !== "CATEGORY")) {
          return null;
        }

        return {
          id: categoryId,
          name:
            item?.name ??
            item?.categoryName ??
            item?.referenceName ??
            matchedCategory?.name ??
            "",
          parentName: item?.parentName ?? matchedCategory?.parentName ?? "",
          type: valueType,
          value,
        };
      })
      .filter((item) => item && item.id && item.type && item.value !== "");
  };

  const handleCategoryImportButtonClick = () => {
    if (!data.countryId) {
      toast.error("Morate odabrati drzavu pre importa kategorija", {
        theme: "colored",
      });
      return;
    }

    categoryImportInputRef.current?.click();
  };

  const handleCategoryImport = async (event) => {
    const selectedFile = event.target.files?.[0];
    event.target.value = "";

    if (!selectedFile) {
      return;
    }

    const isExcelFile =
      [
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.ms-excel",
      ].includes(selectedFile.type) || /\.(xlsx|xls)$/i.test(selectedFile.name);

    if (!isExcelFile) {
      toast.error("Morate izabrati Excel fajl (.xlsx ili .xls)", {
        theme: "colored",
      });
      return;
    }

    if (!data.countryId) {
      toast.error("Morate odabrati drzavu pre importa kategorija", {
        theme: "colored",
      });
      return;
    }

    const formData = new FormData();
    formData.append("file", selectedFile);
    formData.append("countryId", data.countryId);
    formData.append("type", "CATEGORY");

    setIsImportingCategories(true);

    try {
      const responseData = await dispatch(fetchImportPromotionProducts(formData));

      if (!responseData) {
        return;
      }

      const importedCategories =
        normalizeImportedPromotionCategories(responseData);

      if (importedCategories.length === 0) {
        toast.error("U odabranom fajlu nema kategorija za import", {
          theme: "colored",
        });
        return;
      }

      const uniqueImportedCategories = importedCategories.filter(
        (item, index, array) =>
          array.findIndex((category) => category.id === item.id) === index
      );
      const existingCategoryIds = new Set(
        dataForm.categoryList.map((category) => category.id)
      );
      const categoriesToAdd = uniqueImportedCategories.filter(
        (category) => !existingCategoryIds.has(category.id)
      );

      if (categoriesToAdd.length === 0) {
        toast.error("Sve kategorije iz fajla su vec dodate", {
          theme: "colored",
        });
        return;
      }

      setDataForm((prevState) => ({
        ...prevState,
        categoryList: [...prevState.categoryList, ...categoriesToAdd],
      }));
    } finally {
      setIsImportingCategories(false);
    }
  };

  const handleProductImportButtonClick = () => {
    if (!data.countryId) {
      toast.error("Morate odabrati drzavu pre importa proizvoda", {
        theme: "colored",
      });
      return;
    }

    productImportInputRef.current?.click();
  };

  const handleProductImport = async (event) => {
    const selectedFile = event.target.files?.[0];
    event.target.value = "";

    if (!selectedFile) {
      return;
    }

    const isExcelFile =
      [
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.ms-excel",
      ].includes(selectedFile.type) || /\.(xlsx|xls)$/i.test(selectedFile.name);

    if (!isExcelFile) {
      toast.error("Morate izabrati Excel fajl (.xlsx ili .xls)", {
        theme: "colored",
      });
      return;
    }

    if (!data.countryId) {
      toast.error("Morate odabrati drzavu pre importa proizvoda", {
        theme: "colored",
      });
      return;
    }

    const formData = new FormData();
    formData.append("file", selectedFile);
    formData.append("countryId", data.countryId);
    formData.append("type", "PRODUCT");

    setIsImportingProducts(true);

    try {
      const responseData = await dispatch(fetchImportPromotionProducts(formData));

      if (!responseData) {
        return;
      }

      const importedProducts = normalizeImportedPromotionProducts(responseData);

      if (importedProducts.length === 0) {
        toast.error("U odabranom fajlu nema proizvoda za import", {
          theme: "colored",
        });
        return;
      }

      const uniqueImportedProducts = importedProducts.filter(
        (item, index, array) =>
          array.findIndex((product) => product.id === item.id) === index
      );
      const existingProductIds = new Set(
        dataForm.productList.map((product) => product.id)
      );
      const productsToAdd = uniqueImportedProducts.filter(
        (product) => !existingProductIds.has(product.id)
      );

      if (productsToAdd.length === 0) {
        toast.error("Svi proizvodi iz fajla su vec dodati", {
          theme: "colored",
        });
        return;
      }

      setDataForm((prevState) => ({
        ...prevState,
        productList: [...prevState.productList, ...productsToAdd],
      }));
    } finally {
      setIsImportingProducts(false);
    }
  };

  const handleAddToFormTable = () => {
    if (selectedCompany) {
      // Proveri da li kompanija već postoji u companyList
      const isCompanyExists = dataForm.companyList.some(
        (company) => company.id === selectedCompany.id
      );

      if (!isCompanyExists) {
        setDataForm((prevState) => ({
          ...prevState,
          companyList: [...prevState.companyList, selectedCompany],
        }));
        setSelectedCompany(null);
      } else {
        toast.error("Ova kompanija je već dodata!", { theme: "colored" });
      }
    }
  };

  const handleAddToFormTableStore = () => {
    if (selectedStore) {
      // Proveri da li radnja već postoji u storeList
      const isStoreExists = dataForm.storeList.some(
        (store) => store.id === selectedStore.id
      );

      if (!isStoreExists) {
        setDataForm((prevState) => ({
          ...prevState,
          storeList: [...prevState.storeList, selectedStore],
        }));
        setSelectedStore(null);
      } else {
        toast.error("Ova radnja je već dodata!", { theme: "colored" });
      }
    }
  };

  const handleAddToFormTableAccount = () => {
    if (selectedAccount) {
      const isAccountExists = dataForm.accountList.some(
        (account) => account.id === selectedAccount.id
      );

      if (!isAccountExists) {
        setDataForm((prevState) => ({
          ...prevState,
          accountList: [...prevState.accountList, selectedAccount],
        }));
        setSelectedAccount(null);
      } else {
        toast.error("Ovaj korisnik je već dodata!", { theme: "colored" });
      }
    }
  };

  const handleRemoveFromFormTable = (id) => {
    setDataForm((prevState) => ({
      ...prevState,
      companyList: prevState.companyList.filter((company) => company.id !== id),
    }));
  };
  const handleRemoveFromFormTableStore = (id) => {
    setDataForm((prevState) => ({
      ...prevState,
      storeList: prevState.storeList.filter((store) => store.id !== id),
    }));
  };
  const handleRemoveFromFormTableAccount = (id) => {
    setDataForm((prevState) => ({
      ...prevState,
      accountList: prevState.accountList.filter((account) => account.id !== id),
    }));
  };
  const handleRemoveFromFormTableCategory = (id) => {
    setDataForm((prevState) => ({
      ...prevState,
      categoryList: prevState.categoryList.filter(
        (category) => category.id !== id
      ),
    }));
  };
  const handleRemoveFromFormTableProduct = (id) => {
    setDataForm((prevState) => ({
      ...prevState,
      productList: prevState.productList.filter((pro) => pro.id !== id),
    }));
  };

  const initialState = {
    name: "",
    countryId: "",
    status: "ACTIVE",
    startDate: "",
    endDate: "",
  };

  const [data, setData] = useState(initialState);
  const [errors, setErrors] = useState({});
  const [image, setImage] = useState(null);

  const { promotionDetail } = useSelector((state) => state.promotionReducer);

  const { countryFormList } = useSelector((state) => state.countryReducer);
  const { customerExtendedFormList } = useSelector(
    (state) => state.customerReducer
  );
  const { productList } = useSelector((state) => state.productReducer);
  const { storeFormExtendedList } = useSelector((state) => state.storeReducer);
  const { companyFormList } = useSelector((state) => state.companyReducer);
  const { productCategoryAllFormList } = useSelector(
    (state) => state.productCategoryReducer
  );

  const handleInputChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const handleInputChangeCountry = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
    dispatch(fetchProductListPromotion(e.target.value));
    dispatch(fetchStoreFormExtendedList(e.target.value));
    dispatch(fetchCustomFormExtendedList(e.target.value));
    dispatch(fetchCompanyFormList(e.target.value));
    dispatch(fetchProductCategoryAllFormList(e.target.value));
  };

  // Primer korišćenja:
  const allCategoryList = flattenCategories(productCategoryAllFormList);

  useEffect(() => {
    dispatch(fetchCountryFormList());
  }, [dispatch]);

  useEffect(() => {
    if (!id) {
      // Ako `id` ne postoji, očisti stanje za novu kreaciju
      setData(initialState);
      setDataForm({
        companyList: [],
        storeList: [],
        accountList: [],
        categoryList: [],
        productList: [],
      });
    } else {
      // Ako `id` postoji, učitaj podatke za promociju
      dispatch(fetchPromotionList(id));
    }
  }, [id, dispatch]);

  useEffect(() => {
    if (promotionDetail) {
      setData({
        ...data,
        name: promotionDetail.name || "",
        startDate: promotionDetail.startDate || "",
        image: promotionDetail.banner || "",
        endDate: promotionDetail.endDate || "",
        status: promotionDetail.status || "ACTIVE",
        countryId: promotionDetail.countryId || "",
        companies: promotionDetail.companies || [],
        stores: promotionDetail.stores || [],
        accounts: promotionDetail.accounts || [],
        items: promotionDetail.items || [],
        createdAt: promotionDetail.createdAt || "",
        updatedAt: promotionDetail.updatedAt || "",
      });

      if (promotionDetail.countryId) {
        dispatch(fetchProductListPromotion(promotionDetail.countryId));
        dispatch(fetchStoreFormExtendedList(promotionDetail.countryId));
        dispatch(fetchCustomFormExtendedList(promotionDetail.countryId));
        dispatch(fetchCompanyFormList(promotionDetail.countryId));
        dispatch(fetchProductCategoryAllFormList(promotionDetail.countryId));
      }
    }
  }, [promotionDetail, dispatch]);

  useEffect(() => {
    if (companyFormList.length > 0 && id) {
      //pronalazim selektovane kompanije
      const selectedCompanies = companyFormList.filter((company) =>
        data?.companies?.includes(company.id)
      );
      //setujem selektovane kompanije
      setDataForm((prevState) => ({
        ...prevState,
        companyList: selectedCompanies,
      }));
    }
  }, [companyFormList]);

  useEffect(() => {
    if (storeFormExtendedList.length > 0 && id) {
      //pronalazim selektovane kompanije
      const selectedStores = storeFormExtendedList.filter((store) =>
        data?.stores?.includes(store.id)
      );
      //setujem selektovane kompanije
      setDataForm((prevState) => ({
        ...prevState,
        storeList: selectedStores,
      }));
    }
  }, [storeFormExtendedList]);

  useEffect(() => {
    if (customerExtendedFormList.length > 0 && id) {
      //pronalazim selektovane kompanije
      const selectedAccount = customerExtendedFormList.filter((account) =>
        data?.accounts?.includes(account.id)
      );
      //setujem selektovane kompanije
      setDataForm((prevState) => ({
        ...prevState,
        accountList: selectedAccount,
      }));
    }
  }, [customerExtendedFormList]);

  useEffect(() => {
    if (countryFormList?.length == 1) {
      setData((prevData) => ({
        ...prevData,
        countryId: countryFormList[0].id,
      }));
      dispatch(fetchProductListPromotion(countryFormList[0].id));
      dispatch(fetchStoreFormExtendedList(countryFormList[0].id));
      dispatch(fetchCustomFormExtendedList(countryFormList[0].id));
      dispatch(fetchCompanyFormList(countryFormList[0].id));
      dispatch(fetchProductCategoryAllFormList(countryFormList[0].id));
    }
  }, [countryFormList]);

  useEffect(() => {
    if (productCategoryAllFormList.length > 0 && id) {
      // Primer korišćenja:
      const categoryListAll = flattenCategories(productCategoryAllFormList);

      // Filtriranje svih 'CATEGORY' tipova iz data.items
      const selectedCategories = categoryListAll.filter((category) =>
        data?.items?.some(
          (item) => item.referenceId === category.id && item.type === "CATEGORY"
        )
      );

      // Kreiranje novih objekata sa potrebnim vrednostima
      const newCategoryList = selectedCategories.map((category) => {
        const item = data.items.find(
          (item) => item.referenceId === category.id && item.type === "CATEGORY"
        );

        // Kreiranje novog objekta sa vrednostima iz item-a
        const newCategory = {
          id: category.id,
          name: category.name,
          parentName: category.parentName,
          type: item?.valueType, // type = valueType iz data.items
          value: item?.value, // value = value iz data.items
        };

        return newCategory;
      });

      // Ažuriranje categoryList sa novim kategorijama bez dupliranja
      setDataForm((prevState) => ({
        ...prevState,
        categoryList: [
          ...prevState.categoryList,
          ...newCategoryList.filter(
            (newCategory) =>
              !prevState.categoryList.some(
                (category) => category.id === newCategory.id
              )
          ),
        ],
      }));
    }
  }, [productCategoryAllFormList, data]);

  useEffect(() => {
    if (productList.length > 0 && id) {
      // Filtriranje svih 'PRODUCT' tipova iz data.items
      const selectedProducts = productList.filter((product) =>
        data?.items?.some(
          (item) => item.referenceId === product.id && item.type === "PRODUCT"
        )
      );

      // Kreiranje novih objekata sa potrebnim vrednostima
      const newProductList = selectedProducts.map((product) => {
        const item = data.items.find(
          (item) => item.referenceId === product.id && item.type === "PRODUCT"
        );

        // Kreiranje novog objekta sa vrednostima iz item-a
        const newProduct = {
          id: product.id,
          name: product.name,
          categoryName: product.categoryName,
          type: item?.valueType, // type = valueType iz data.items
          value: item?.value, // value = value iz data.items
        };

        return newProduct;
      });

      // Ažuriranje productList sa novim proizvodima bez dupliranja
      setDataForm((prevState) => ({
        ...prevState,
        productList: [
          ...prevState.productList,
          ...newProductList.filter(
            (newProduct) =>
              !prevState.productList.some(
                (product) => product.id === newProduct.id
              )
          ),
        ],
      }));
    }
  }, [productList, data]);

  const clientValidationHandler = () => {
    const { name, countryId, startDate, endDate } = data;

    let errorsObject = {};

    errorsObject = basicFormValidationHandler({
      name,
      startDate,
      endDate,
      countryId,
    });

    setErrors(errorsObject);

    if (!isEmpty(errorsObject))
      toast.error("Morate popuniti sva obavezna polja", { theme: "colored" });
    return !isEmpty(errorsObject);
  };

  const handleFileDelete = (fieldName) => {
    switch (fieldName) {
      case "image":
        setImage(null);
      default:
        break;
    }

    // Resetovanje input polja
    //TODO: Ispraviti da ide preko refa
    document.getElementById(`file-input-${fieldName}`).value = "";
  };

  const handleFileChange = (event) => {
    const name = event.target.name;
    const selectedFile = event.target.files[0];
    if (
      (selectedFile && selectedFile.type === "image/jpeg") ||
      selectedFile.type === "image/png"
    ) {
      switch (name) {
        case "image":
          setImage(selectedFile);
          break;
        default:
          return;
      }
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (clientValidationHandler()) {
      return;
    }

    if (
      dataForm.categoryList.length === 0 &&
      dataForm.productList.length === 0
    ) {
      toast.error("Morate odabrati kategoriju ili proizvod", {
        theme: "colored",
      });
      return;
    }

    let formData = new FormData();

    if (
      Array.isArray(dataForm?.categoryList) &&
      dataForm?.categoryList?.length > 0
    ) {
      dataForm?.categoryList?.forEach((item, index) => {
        formData.append(`items[${index}].referenceId`, item?.id);
        formData.append(`items[${index}].value`, item?.value);
        formData.append(`items[${index}].type`, "CATEGORY");
        formData.append(`items[${index}].valueType`, item?.type);
      });
    }

    if (
      Array.isArray(dataForm?.productList) &&
      dataForm?.productList?.length > 0
    ) {
      let offset = dataForm?.categoryList?.length || 0; // Pomera indeks ako ima kategorija
      dataForm?.productList?.forEach((item, index) => {
        let newIndex = offset + index;
        formData.append(`items[${newIndex}].referenceId`, item?.id);
        formData.append(`items[${newIndex}].value`, item?.value);
        formData.append(`items[${newIndex}].type`, "PRODUCT");
        formData.append(`items[${newIndex}].valueType`, item?.type);
      });
    }

    if (dataForm?.companyList?.length > 0)
      dataForm?.companyList?.forEach((comapny) =>
        formData.append("companies", comapny.id)
      );

    if (dataForm?.storeList?.length > 0)
      dataForm?.storeList?.forEach((store) =>
        formData.append("stores", store.id)
      );

    if (dataForm?.accountList?.length > 0)
      dataForm?.accountList?.forEach((account) =>
        formData.append("accounts", account.id)
      );

    formData.append("banner", image);
    formData.append("name", data.name);
    formData.append("startDate", data.startDate);
    formData.append("endDate", data.endDate);
    formData.append("status", data.status);
    formData.append("countryId", data.countryId);

    if (id) {
      formData.append("id", id);
      dispatch(fetchEditPromotion(formData, navigate));
    } else {
      dispatch(createNewPromotion(formData, navigate));
    }
  };

  return (
    <Fragment>
      <Breadcrumb
        breadcrumbItems={breadcrumbItems}
        type={translateModule}
        id={id}
        pageType={pageType}
        extraTitle={promotionDetail && promotionDetail.name}
      />
      <Container>
        <Row>
          <Col lg={12}>
            <form onSubmit={handleSubmit} noValidate>
              <Row>
                <Col lg={12}>
                  <div className="text-end mb-2">
                    <SubmitButtonForm id={id} />
                  </div>
                </Col>
              </Row>

              <Row>
                <Col lg={9}>
                  <Row>
                    <Col lg={12}>
                      <Card>
                        <Card.Header>
                          <FormTitleMain />
                        </Card.Header>
                        <Card.Body>
                          <div className="promotion-holder-admin-left-side-text">
                            <Row>
                              <Col lg={8} md={12} xs={12} className="mb-4">
                                <InputField
                                  label={t("promotionAddForm.nameLabel")}
                                  name="name"
                                  value={data?.name}
                                  onChange={handleInputChange}
                                  error={errors}
                                  errorsHandler={setErrors}
                                  fullWidth
                                  size="small"
                                  required
                                />
                              </Col>
                              <Col lg={4} md={12} xs={12} className="mb-3">
                                <FormControl
                                  fullWidth
                                  required
                                  size="small"
                                  error={errors?.levelId ? true : false}
                                  disabled={id || countryFormList?.length == 1}
                                >
                                  <InputLabel id="demo-simple-select-label">
                                    {t("promotionAddForm.countryLabel")}
                                  </InputLabel>
                                  <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={data?.countryId}
                                    label={t("promotionAddForm.countryLabel")}
                                    name="countryId"
                                    onChange={handleInputChangeCountry}
                                    size="small"
                                  >
                                    {countryFormList?.map((item, key) => (
                                      <MenuItem value={item.id} key={key}>
                                        {item.name}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                  {errors?.countryId && (
                                    <FormHelperText>
                                      {t("promotionAddForm.requiredField")}
                                    </FormHelperText>
                                  )}
                                </FormControl>
                              </Col>
                              <Col lg={4} md={12} xs={12} className="mb-4">
                                <InputField
                                  type="date"
                                  label={t("promotionAddForm.startDateLabel")}
                                  name="startDate"
                                  value={data?.startDate}
                                  onChange={handleInputChange}
                                  error={errors}
                                  errorsHandler={setErrors}
                                  fullWidth
                                  size="small"
                                  required
                                  disabled={id}
                                  inputLabelProps={{ shrink: true }}
                                  inputProps={{
                                    max: data?.endDate || undefined,
                                  }}
                                />
                              </Col>
                              <Col lg={4} md={12} xs={12} className="mb-4">
                                <InputField
                                  type="date"
                                  label={t("promotionAddForm.endDateLabel")}
                                  name="endDate"
                                  value={data?.endDate}
                                  onChange={handleInputChange}
                                  error={errors}
                                  errorsHandler={setErrors}
                                  fullWidth
                                  size="small"
                                  required
                                  disabled={id}
                                  inputLabelProps={{ shrink: true }}
                                  inputProps={{
                                    min: data?.startDate || undefined,
                                  }}
                                />
                              </Col>
                            </Row>
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>
                    {data.countryId && (
                      <Fragment>
                        <Col lg={6}>
                          <Card>
                            <Card.Header>
                              {t("promotionAddForm.companyLabel")}
                            </Card.Header>
                            <Card.Body>
                              <Row>
                                <Col lg={12}>
                                  <div className="form-input-add-holder d-flex gap-2 justify-content-between align-items-center mb-3">
                                    <Autocomplete
                                      options={companyFormList}
                                      getOptionLabel={(option) => option.name}
                                      fullWidth
                                      value={selectedCompany}
                                      onChange={(e, newValue) => {
                                        setSelectedCompany(newValue);
                                      }}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          label={t(
                                            "promotionAddForm.companyLabel"
                                          )}
                                          size="small"
                                        />
                                      )}
                                    />
                                    <Button
                                      variant="contained"
                                      onClick={handleAddToFormTable}
                                      startIcon={<AddIcon />}
                                    >
                                      Dodaj
                                    </Button>
                                  </div>
                                  {dataForm?.companyList?.length > 0 ? (
                                    <Table
                                      bordered
                                      hover
                                      size="sm"
                                      responsive="sm"
                                      striped
                                      className="mb-0"
                                    >
                                      <thead>
                                        <tr>
                                          <th className="text-center text-bold">
                                            {t("promotionAddForm.companyLabel")}
                                          </th>
                                          <th
                                            className="text-center"
                                            width="1%"
                                          ></th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {dataForm?.companyList?.map(
                                          (item, key) => (
                                            <tr key={key}>
                                              <td>{item.name}</td>
                                              <td className="text-center">
                                                <CloseIcon
                                                  sx={{ cursor: "pointer" }}
                                                  onClick={() =>
                                                    handleRemoveFromFormTable(
                                                      item.id
                                                    )
                                                  }
                                                />
                                              </td>
                                            </tr>
                                          )
                                        )}
                                      </tbody>
                                    </Table>
                                  ) : (
                                    <Alert severity="info">
                                      {t("promotionAddForm.noCompanySelected")}
                                    </Alert>
                                  )}
                                </Col>
                              </Row>
                            </Card.Body>
                          </Card>
                        </Col>

                        {/* Radnja Section */}
                        <Col lg={6}>
                          <Card>
                            <Card.Header>
                              {t("promotionAddForm.storeLabel")}
                            </Card.Header>
                            <Card.Body>
                              <Row>
                                <Col lg={12}>
                                  <div className="form-input-add-holder d-flex gap-2 justify-content-between align-items-center mb-3">
                                    <Autocomplete
                                      options={storeFormExtendedList}
                                      getOptionLabel={(option) => option.name}
                                      fullWidth
                                      value={selectedStore}
                                      onChange={(e, newValue) => {
                                        setSelectedStore(newValue);
                                      }}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          label={t(
                                            "promotionAddForm.storeLabel"
                                          )}
                                          size="small"
                                        />
                                      )}
                                    />
                                    <Button
                                      variant="contained"
                                      onClick={handleAddToFormTableStore}
                                      startIcon={<AddIcon />}
                                    >
                                      Dodaj
                                    </Button>
                                  </div>
                                  {dataForm?.storeList?.length > 0 ? (
                                    <Table
                                      bordered
                                      hover
                                      size="sm"
                                      responsive="sm"
                                      striped
                                      className="mb-0"
                                    >
                                      <thead>
                                        <tr>
                                          <th className="text-center text-bold">
                                            {t("promotionAddForm.storeLabel")}
                                          </th>
                                          <th className="text-center text-bold">
                                            {t("promotionAddForm.companyLabel")}
                                          </th>
                                          <th
                                            className="text-center"
                                            width="1%"
                                          ></th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {dataForm?.storeList?.map(
                                          (item, key) => (
                                            <tr key={key}>
                                              <td>{item.name}</td>
                                              <td>{item.companyName}</td>
                                              <td className="text-center">
                                                <CloseIcon
                                                  sx={{ cursor: "pointer" }}
                                                  onClick={() =>
                                                    handleRemoveFromFormTableStore(
                                                      item.id
                                                    )
                                                  }
                                                />
                                              </td>
                                            </tr>
                                          )
                                        )}
                                      </tbody>
                                    </Table>
                                  ) : (
                                    <Alert severity="info">
                                      {t("promotionAddForm.noStoreSelected")}
                                    </Alert>
                                  )}
                                </Col>
                              </Row>
                            </Card.Body>
                          </Card>
                        </Col>
                        <Col lg={12}>
                          <Card>
                            <Card.Header>
                              {t("promotionAddForm.userSelection")}
                            </Card.Header>
                            <Card.Body>
                              <Row>
                                <Col lg={12}>
                                  <div className="form-input-add-holder d-flex gap-2 justify-content-between align-items-center mb-3">
                                    <Autocomplete
                                      options={customerExtendedFormList}
                                      getOptionLabel={(option) =>
                                        `${option.name} ${option.lastName} (${
                                          option.companyName
                                        } / ${option.storeName} / ${t(
                                          `global.${option.sector}`
                                        )})`
                                      }
                                      fullWidth
                                      value={selectedAccount}
                                      onChange={(e, newValue) => {
                                        setSelectedAccount(newValue);
                                      }}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          label={t(
                                            "promotionAddForm.user.label"
                                          )}
                                          size="small"
                                        />
                                      )}
                                    />

                                    <Button
                                      variant="contained"
                                      onClick={handleAddToFormTableAccount}
                                      startIcon={<AddIcon />}
                                    >
                                      {t("promotionAddForm.user.addButton")}
                                    </Button>
                                  </div>
                                  {dataForm?.accountList?.length > 0 ? (
                                    <Table
                                      bordered
                                      hover
                                      size="sm"
                                      responsive="sm"
                                      striped
                                      className="mb-0"
                                    >
                                      <thead>
                                        <tr>
                                          <th className="text-center text-bold">
                                            {t(
                                              "promotionAddForm.accountTable.headers.user"
                                            )}
                                          </th>
                                          <th className="text-center text-bold">
                                            {t(
                                              "promotionAddForm.accountTable.headers.company"
                                            )}
                                          </th>
                                          <th className="text-center text-bold">
                                            {t(
                                              "promotionAddForm.accountTable.headers.store"
                                            )}
                                          </th>
                                          <th className="text-center text-bold">
                                            {t("promotionAddForm.sectorName")}
                                          </th>
                                          <th
                                            className="text-center"
                                            width="1%"
                                          ></th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {dataForm?.accountList?.map(
                                          (item, key) => (
                                            <tr key={key}>
                                              <td className="">
                                                {item.name} {item.lastName}
                                              </td>
                                              <td className="">
                                                {item.companyName}
                                              </td>
                                              <td className="">
                                                {item.storeName}
                                              </td>
                                              <td className="">
                                                {t(`global.${item.sector}`)}
                                              </td>
                                              <td className="text-center">
                                                <CloseIcon
                                                  sx={{ cursor: "pointer" }}
                                                  onClick={() =>
                                                    handleRemoveFromFormTableAccount(
                                                      item.id
                                                    )
                                                  }
                                                />
                                              </td>
                                            </tr>
                                          )
                                        )}
                                      </tbody>
                                    </Table>
                                  ) : (
                                    <Alert severity="info">
                                      {t(
                                        "promotionAddForm.accountTable.noUserSelected"
                                      )}
                                    </Alert>
                                  )}
                                </Col>
                              </Row>
                            </Card.Body>
                          </Card>
                        </Col>

                        <Col lg={12}>
                          <Card>
                            <Card.Header>
                              <div className="d-flex align-items-center justify-content-between">
                                <div className="card-title-item">
                                  {t(
                                    "promotionAddForm.categorySelection.header"
                                  )}
                                </div>
                                <div className="card-button-header-item">
                                  <input
                                    ref={categoryImportInputRef}
                                    type="file"
                                    hidden
                                    accept=".xlsx,.xls"
                                    onChange={handleCategoryImport}
                                  />
                                  <Button
                                    variant="contained"
                                    color="warning"
                                    size="small"
                                    onClick={handleCategoryImportButtonClick}
                                    startIcon={<FileUploadRoundedIcon />}
                                    disabled={!data.countryId || isImportingCategories}
                                  >
                                    {t(
                                      "promotionAddForm.categorySelection.importButton"
                                    )}
                                  </Button>
                                </div>
                              </div>
                            </Card.Header>
                            <Card.Body>
                              <div className="form-input-add-holder">
                                <Row>
                                  <Col lg={6} md={12} xs={12} className="mb-4">
                                    <Autocomplete
                                      options={allCategoryList}
                                      getOptionLabel={(option) =>
                                        option.parentName
                                          ? `${option.name} (${option.parentName})`
                                          : option.name
                                      }
                                      value={selectedCategory}
                                      onChange={(e, newValue) => {
                                        handleInputChangeCategory(
                                          "categoryId",
                                          newValue
                                        );
                                      }}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          label={t(
                                            "promotionAddForm.categorySelection.categoryLabel"
                                          )}
                                          size="small"
                                        />
                                      )}
                                    />
                                  </Col>
                                  <Col lg={2} md={12} xs={12} className="mb-4">
                                    <FormControl
                                      fullWidth
                                      required
                                      size="small"
                                    >
                                      <InputLabel id="demo-simple-select-label">
                                        {t(
                                          "promotionAddForm.categorySelection.typeLabel"
                                        )}
                                      </InputLabel>
                                      <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={selectedCategoryType}
                                        label={t(
                                          "promotionAddForm.categorySelection.typeLabel"
                                        )}
                                        name="type"
                                        onChange={(e) =>
                                          handleInputChangeCategory(
                                            "type",
                                            e.target.value
                                          )
                                        }
                                        size="small"
                                      >
                                        <MenuItem value="FLAT">
                                          {t(
                                            "promotionAddForm.categoryTypes.flat"
                                          )}
                                        </MenuItem>
                                        <MenuItem value="PERCENTAGE">
                                          {t(
                                            "promotionAddForm.categoryTypes.percentage"
                                          )}
                                        </MenuItem>
                                      </Select>
                                    </FormControl>
                                  </Col>
                                  <Col lg={2} md={12} xs={12} className="mb-4">
                                    <InputField
                                      label={t(
                                        "promotionAddForm.categorySelection.valueLabel"
                                      )}
                                      name="value"
                                      value={selectedCategoryValue}
                                      onChange={(e) =>
                                        handleInputChangeCategory(
                                          "value",
                                          e.target.value
                                        )
                                      }
                                      fullWidth
                                      size="small"
                                    />
                                  </Col>
                                  <Col lg={2} md={12} xs={12} className="mb-4">
                                    <Button
                                      variant="contained"
                                      onClick={handleAddToFormTableCategory}
                                      startIcon={<AddIcon />}
                                    >
                                      {t(
                                        "promotionAddForm.categorySelection.addButton"
                                      )}
                                    </Button>
                                  </Col>
                                </Row>
                              </div>
                              {dataForm?.categoryList?.length > 0 ? (
                                <Table
                                  bordered
                                  hover
                                  size="sm"
                                  responsive="sm"
                                  striped
                                  className="mb-0"
                                >
                                  <thead>
                                    <tr>
                                      <th className="text-center text-bold">
                                        {t(
                                          "promotionAddForm.categoryTable.headers.category"
                                        )}
                                      </th>
                                      <th
                                        className="text-center text-bold"
                                        width="20%"
                                      >
                                        {t(
                                          "promotionAddForm.categoryTable.headers.type"
                                        )}
                                      </th>
                                      <th
                                        className="text-center text-bold"
                                        width="10%"
                                      >
                                        {t(
                                          "promotionAddForm.categoryTable.headers.value"
                                        )}
                                      </th>
                                      <th
                                        className="text-center"
                                        width="1%"
                                      ></th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {dataForm?.categoryList?.map(
                                      (item, key) => (
                                        <tr key={key}>
                                          <td className="">{item.name}</td>
                                          <td className="">
                                            {item.type === "FLAT"
                                              ? t(
                                                  "promotionAddForm.categoryTypes.flat"
                                                )
                                              : t(
                                                  "promotionAddForm.categoryTypes.percentage"
                                                )}
                                          </td>
                                          <td className="">{item.value}</td>
                                          <td className="text-center">
                                            <CloseIcon
                                              sx={{ cursor: "pointer" }}
                                              onClick={() =>
                                                handleRemoveFromFormTableCategory(
                                                  item.id
                                                )
                                              }
                                            />
                                          </td>
                                        </tr>
                                      )
                                    )}
                                  </tbody>
                                </Table>
                              ) : (
                                <Alert severity="info">
                                  {t(
                                    "promotionAddForm.categorySelection.noCategorySelected"
                                  )}
                                </Alert>
                              )}
                            </Card.Body>
                          </Card>
                        </Col>

                        <Col lg={12}>
                          <Card>
                            <Card.Header>
                              <div className="d-flex align-items-center justify-content-between">
                                <div className="card-title-item">
                                  {t(
                                    "promotionAddForm.productSelection.header"
                                  )}
                                </div>
                                <div className="card-button-header-item">
                                  <input
                                    ref={productImportInputRef}
                                    type="file"
                                    hidden
                                    accept=".xlsx,.xls"
                                    onChange={handleProductImport}
                                  />
                                  <Button
                                    variant="contained"
                                    color="warning"
                                    size="small"
                                    onClick={handleProductImportButtonClick}
                                    startIcon={<FileUploadRoundedIcon />}
                                    disabled={!data.countryId || isImportingProducts}
                                  >
                                    {t("button.import")}
                                  </Button>
                                </div>
                              </div>
                            </Card.Header>
                            <Card.Body>
                              <div className="form-input-add-holder">
                                <Row>
                                  <Col lg={6} md={12} xs={12} className="mb-4">
                                    <Autocomplete
                                      options={productList}
                                      getOptionLabel={(option) =>
                                        option.parentName
                                          ? `${option.name} (${option.parentName})`
                                          : option.name
                                      }
                                      value={selectedProduct}
                                      onChange={(e, newValue) => {
                                        handleInputChangeProduct(
                                          "productId",
                                          newValue
                                        );
                                      }}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          label={t(
                                            "promotionAddForm.productSelection.productLabel"
                                          )}
                                          size="small"
                                        />
                                      )}
                                    />
                                  </Col>
                                  <Col lg={2} md={12} xs={12} className="mb-4">
                                    <FormControl
                                      fullWidth
                                      required
                                      size="small"
                                    >
                                      <InputLabel id="demo-simple-select-label">
                                        {t(
                                          "promotionAddForm.productSelection.typeLabel"
                                        )}
                                      </InputLabel>
                                      <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={selectedProductType}
                                        label={t(
                                          "promotionAddForm.productSelection.typeLabel"
                                        )}
                                        name="type"
                                        onChange={(e) =>
                                          handleInputChangeProduct(
                                            "type",
                                            e.target.value
                                          )
                                        }
                                        size="small"
                                      >
                                        <MenuItem value="FLAT">
                                          {t(
                                            "promotionAddForm.productTypes.flat"
                                          )}
                                        </MenuItem>
                                        <MenuItem value="PERCENTAGE">
                                          {t(
                                            "promotionAddForm.productTypes.percentage"
                                          )}
                                        </MenuItem>
                                      </Select>
                                    </FormControl>
                                  </Col>
                                  <Col lg={2} md={12} xs={12} className="mb-4">
                                    <InputField
                                      label={t(
                                        "promotionAddForm.productSelection.valueLabel"
                                      )}
                                      name="value"
                                      value={selectedProductValue}
                                      onChange={(e) =>
                                        handleInputChangeProduct(
                                          "value",
                                          e.target.value
                                        )
                                      }
                                      fullWidth
                                      size="small"
                                    />
                                  </Col>
                                  <Col lg={2} md={12} xs={12} className="mb-4">
                                    <Button
                                      variant="contained"
                                      onClick={handleAddToFormTableProduct}
                                      startIcon={<AddIcon />}
                                    >
                                      {t(
                                        "promotionAddForm.productSelection.addButton"
                                      )}
                                    </Button>
                                  </Col>
                                </Row>
                              </div>
                              {dataForm?.productList?.length > 0 ? (
                                <Table
                                  bordered
                                  hover
                                  size="sm"
                                  responsive="sm"
                                  striped
                                  className="mb-0"
                                >
                                  <thead>
                                    <tr>
                                      <th className="text-center text-bold">
                                        {t(
                                          "promotionAddForm.productTable.headers.category"
                                        )}
                                      </th>
                                      <th className="text-center text-bold">
                                        {t(
                                          "promotionAddForm.productTable.headers.parentCategory"
                                        )}
                                      </th>
                                      <th
                                        className="text-center text-bold"
                                        width="20%"
                                      >
                                        {t(
                                          "promotionAddForm.productTable.headers.type"
                                        )}
                                      </th>
                                      <th
                                        className="text-center text-bold"
                                        width="10%"
                                      >
                                        {t(
                                          "promotionAddForm.productTable.headers.value"
                                        )}
                                      </th>
                                      <th
                                        className="text-center"
                                        width="1%"
                                      ></th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {dataForm?.productList?.map((item, key) => (
                                      <tr key={key}>
                                        <td className="">{item.name}</td>
                                        <td className="">
                                          {item.categoryName}
                                        </td>
                                        <td className="">
                                          {item.type === "FLAT"
                                            ? t(
                                                "promotionAddForm.productTypes.flat"
                                              )
                                            : t(
                                                "promotionAddForm.productTypes.percentage"
                                              )}
                                        </td>
                                        <td className="">{item.value}</td>
                                        <td className="text-center">
                                          <CloseIcon
                                            sx={{ cursor: "pointer" }}
                                            onClick={() =>
                                              handleRemoveFromFormTableProduct(
                                                item.id
                                              )
                                            }
                                          />
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </Table>
                              ) : (
                                <Alert severity="info">
                                  {t(
                                    "promotionAddForm.productSelection.noProductSelected"
                                  )}
                                </Alert>
                              )}
                            </Card.Body>
                          </Card>
                        </Col>
                      </Fragment>
                    )}
                  </Row>
                </Col>
                <Col lg={3}>
                  <Row>
                    <Col lg={12}>
                      <SelectStatus
                        data={data}
                        handleInputChange={handleInputChange}
                      />
                    </Col>
                    <Col lg={12}>
                      <Card>
                        <Card.Header>{t("awardForm.image")}</Card.Header>
                        <Card.Body>
                          <UploadField
                            handleFileChange={handleFileChange}
                            placeholder={t("awardForm.imagePlaceholder")}
                            fieldName={"image"}
                          />
                          {data.image && (
                            <Col lg={12} md={12} xs={12}>
                              <Fragment>
                                <div className="preview-image-holder-admin">
                                  <img
                                    src={data.image}
                                    alt={data.image?.name}
                                    width={`100%`}
                                  />
                                </div>
                              </Fragment>
                            </Col>
                          )}

                          {image && (
                            <Fragment>
                              <div className="mt-2">
                                {t("awardForm.imageChoosen")}:{" "}
                                <b>{image?.name}</b> ({t("awardForm.imageSize")}
                                : {(image?.size / 1048576).toFixed(2)} MB)
                              </div>
                              <div className="preview-image-holder-admin mt-2">
                                <img
                                  src={URL.createObjectURL(image)}
                                  alt={image?.name}
                                  width={`100%`}
                                />
                              </div>
                              <div className="text-end mt-2">
                                <Button
                                  variant="contained"
                                  color="error"
                                  type="button"
                                  size="small"
                                  startIcon={<DeleteIcon />}
                                  onClick={() => handleFileDelete("image")}
                                >
                                  {t("awardForm.imageRemove")}
                                </Button>
                              </div>
                            </Fragment>
                          )}
                        </Card.Body>
                      </Card>
                    </Col>

                    {id && (
                      <Col lg={12}>
                        <FormSystemInformation data={data} />
                      </Col>
                    )}
                  </Row>
                </Col>
              </Row>
            </form>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default PromotionAdd;
